import { isNil } from 'ramda';

export function normalizeItemPosition(position?: number | string) {
    return isNil(position) ? -1 : Number(position) + 1;
}
